import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 28 36",
  "content": "<symbol viewBox=\"0 0 28 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"location\">\r\n<path d=\"M 28,14.4 C 28,22.3529 14,36 14,36 14,36 0,22.3529 0,14.4 0,6.4471 6.268,0 14,0 21.732,0 28,6.4471 28,14.4 Z\" fill=\"#3e8230\" />\r\n<ellipse cx=\"14.0002\" cy=\"13.6663\" rx=\"8.6666698\" ry=\"8.3333302\" fill=\"#ffffff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol